// src/components/Footer.js
import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { contactInfo } from '../data/apartments';

const FooterContainer = styled.footer`
  background: ${props => props.theme.colors.secondary};
  color: white;
  padding: 3rem 0 1rem;
`;

const FooterContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 2rem;
  margin-bottom: 2rem;
`;

const FooterSection = styled.div`
  h3 {
    margin-bottom: 1rem;
    color: ${props => props.theme.colors.primary};
    font-size: 1.3rem;
  }
  
  p {
    margin-bottom: 0.5rem;
    opacity: 0.9;
    line-height: 1.6;
    font-size: 0.95rem;
  }
  
  ul {
    list-style: none;
  }
  
  li {
    margin-bottom: 0.5rem;
  }
  
  a {
    color: white;
    text-decoration: none;
    opacity: 0.8;
    transition: opacity 0.3s ease;
    
    &:hover {
      opacity: 1;
    }
  }
`;

const FooterBottom = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 1rem 20px;
  text-align: center;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  opacity: 0.8;
`;

const Footer = () => {
  return (
    <FooterContainer>
      <FooterContent>
        <FooterSection>
          <h3>Apartamenty w Puławach</h3>
          <p>
            Oferujemy komfortowe apartamenty na wynajem krótkoterminowy
            w najlepszych lokalizacjach.
          </p>
        </FooterSection>

        <FooterSection>
          <h3>Kontakt</h3>
          <p>📞 {contactInfo.phone}</p>
          <p>📧 {contactInfo.email}</p>
          <p>🕒 {contactInfo.hours}</p>
        </FooterSection>

        <FooterSection>
          <h3>Dane firmy</h3>
          <p>{contactInfo.companyName}</p>
          <p>NIP: {contactInfo.nip}</p>
          <p>REGON: {contactInfo.regon}</p>
          <p>{contactInfo.address}</p>
        </FooterSection>

        <FooterSection>
          <h3>Szybkie linki</h3>
          <ul>
            <li>
              <Link to="/apartment/1">Apartament Słoneczny</Link>
            </li>
            <li>
              <Link to="/apartment/2">Apartament Kameralny</Link>
            </li>
            <li>
              <Link to="/contact">Kontakt</Link>
            </li>
          </ul>
        </FooterSection>
      </FooterContent>

      <FooterBottom>
        <p>
          &copy; 2026 Apartamenty przy Parku Czartoryskich. Wszystkie prawa
          zastrzeżone.
        </p>
      </FooterBottom>
    </FooterContainer>
  );
};

export default Footer;